import React, { useRef } from 'react';
import { epochToLocalTime } from '../helpers';
import {
  waterTempProcessing,
  speedProcessing,
  oilPressureProcessing,
  batteryProcessing,
} from './telemetryProcessing';
import { grey } from '@mui/material/colors';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function timeSinceLastUpdate(metric_time) {
  const l = epochToLocalTime(metric_time);
  const elapsedms = Date.now() - l;
  const elapsedSeconds = Math.floor(elapsedms / 1000);
  // console.log(elapsedSeconds);
  return elapsedSeconds;
}

export function VitalLamp({
  metric_name,
  metric_data,
  desired_unit,
  desired_unit_name = desired_unit,
}) {
  const lastReceivedData = useRef(null);
  const chartDataPoint = {
    value: null,
    unit: null,
    color: 'gray',
    lastupdated: null,
  };
  if (metric_data.length > 0) {
    const rawMetric = metric_data?.slice(-1)[0]?.metrics[metric_name];
    if (rawMetric) {
      const lastUpdateTime = timeSinceLastUpdate(rawMetric[0]);
      lastReceivedData.current = lastUpdateTime;
      if (metric_name === 'WATER_TEMP') {
        const [color, value] = waterTempProcessing(rawMetric, desired_unit);
        Object.assign(chartDataPoint, {
          value: value,
          unit: desired_unit,
          color: color,
          lastupdated: timeSinceLastUpdate(rawMetric[0]),
        });
      } else if (metric_name === 'SPEED') {
        const [color, value] = speedProcessing(rawMetric, desired_unit);
        Object.assign(chartDataPoint, {
          value: value,
          unit: desired_unit,
          color: color,
          lastupdated: timeSinceLastUpdate(rawMetric[0]),
        });
      } else if (metric_name === 'BATTERY') {
        const [color, value] = batteryProcessing(rawMetric);
        Object.assign(chartDataPoint, {
          value: value,
          unit: desired_unit,
          color: color,
          lastupdated: timeSinceLastUpdate(rawMetric[0]),
        });
      } else if (metric_name === 'OIL_PRESSURE') {
        const [color, value] = oilPressureProcessing(rawMetric, desired_unit);
        Object.assign(chartDataPoint, {
          value: value,
          unit: desired_unit,
          color: color,
          lastupdated: timeSinceLastUpdate(rawMetric[0]),
        });
      } else {
        console.log('metric name not found');
        const [time, metName, val, unit, min, max] = rawMetric;
        Object.assign(chartDataPoint, {
          value: val,
          unit: unit,
          color: {
            backgroundColor: grey[300],
            borderColor: grey[600],
          },
          lastupdated: timeSinceLastUpdate(rawMetric[0]),
        });
      }
      // if no data received in last 10 seconds
      if (lastReceivedData.current > 10) {
        Object.assign(chartDataPoint, {
          color: {
            // backgroundColor: red[300],
            // borderColor: red[600],
            borderColor: 'rgba(0,0,0, 1.0)',
            backgroundColor: 'rgba(0,0,0, 0.0)',
          },
        });
      }
    } else {
      console.log('else');
    }
  }
  return (
    <Box
      sx={{
        p: 1,
        m: 0,
        border: '3px solid',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '67px',
        width: '67px',
        ...chartDataPoint.color,
      }}
    >
      <Typography variant="h4">
        {!chartDataPoint.value || lastReceivedData.current > 10
          ? '--'
          : chartDataPoint.value}
      </Typography>
      <Typography>{desired_unit_name}</Typography>
      {/* <Typography variant="caption">
          No data for last {lastReceivedData.current}s
        </Typography> */}
    </Box>
  );
}
